/* =========================================================================
   ePaws mega menu — desktop panels + mobile drill-down drawer.
   Vanilla, no dependencies, idempotent. One instance per .epaws-header.
   ========================================================================= */
(function () {
  var roots = [];

  // A tap synthesises mouseenter and focus before click, so hover-opening on a
  // touch device would open the panel and let the same tap's click toggle it
  // shut. Bind hover to pointer events and act only on a real mouse; taps fall
  // through to the click handler, keyboard focus to :focus-visible.
  function isMouse(e) {
    return e.pointerType === 'mouse';
  }

  // A menu item linked to "#" (or nothing) is a label, not a destination.
  // Everything else — collection, page, product — should navigate.
  function isNavigableHref(href) {
    if (!href) return false;
    var value = href.replace(/^\s+|\s+$/g, '');
    if (!value || value === '#' || value === '/#') return false;
    if (value.indexOf('javascript:') === 0) return false;
    return true;
  }

  var supportsFocusVisible = (function () {
    try {
      document.querySelector(':focus-visible');
      return true;
    } catch (e) {
      return false;
    }
  })();

  // Was the focus we're about to see caused by a finger rather than a keypress?
  // Set on pointerdown (capture, so it lands before the synthesised focus) and
  // cleared by any key, so tabbing after a tap still opens panels on focus.
  var focusCameFromTouch = false;
  document.addEventListener(
    'pointerdown',
    function (e) {
      focusCameFromTouch = e.pointerType !== 'mouse';
    },
    true
  );
  document.addEventListener(
    'keydown',
    function () {
      focusCameFromTouch = false;
    },
    true
  );

  function initRoot(root) {
    if (root.__epawsInit) return;
    root.__epawsInit = true;
    roots.push(root);

    var nav = root.querySelector('.ep-nav');
    var closeTimer = null;

    /* ------------------------------ desktop ------------------------------ */
    function panels() {
      return root.querySelectorAll('.ep-panel');
    }
    function navLinks() {
      return root.querySelectorAll('.ep-nav-link');
    }

    function setTopOpen(link, on) {
      link.classList.toggle('is-open', on);
      var toggle = link.parentElement ? link.parentElement.querySelector('.ep-nav-toggle') : null;
      if (!toggle) return;
      toggle.classList.toggle('is-open', on);
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function openMenu(id) {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      panels().forEach(function (p) {
        var on = p.getAttribute('data-panel') === id;
        p.classList.toggle('is-open', on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      navLinks().forEach(function (l) {
        var on = l.getAttribute('data-menu') === id && l.getAttribute('data-haschildren') === '1';
        setTopOpen(l, on);
      });
    }

    function closeMenu() {
      panels().forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      navLinks().forEach(function (l) {
        setTopOpen(l, false);
      });
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMenu, 130);
    }
    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    root.__epCloseMenu = closeMenu;

    if (nav) {
      root.querySelectorAll('.ep-nav-item').forEach(function (li) {
        var link = li.querySelector('.ep-nav-link');
        if (!link) return;
        var id = link.getAttribute('data-menu');
        var hasMenu = link.getAttribute('data-haschildren') === '1';

        li.addEventListener('pointerenter', function (e) {
          if (!isMouse(e)) return;
          if (hasMenu) openMenu(id);
          else closeMenu();
        });

        if (hasMenu) {
          /* Hover and the chevron open the panel. The label keeps its menu
             URL, so a click follows it. A "#" parent has nowhere to go, and
             stays a toggle so it does not jump the page. */
          link.addEventListener('click', function (e) {
            if (isNavigableHref(link.getAttribute('href'))) return;
            e.preventDefault();
            if (link.classList.contains('is-open')) closeMenu();
            else openMenu(id);
          });

          var toggle = li.querySelector('.ep-nav-toggle');
          if (toggle) {
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              if (link.classList.contains('is-open')) closeMenu();
              else openMenu(id);
            });
          }
        }
      });

      nav.addEventListener('pointerleave', function (e) {
        if (isMouse(e)) scheduleClose();
      });

      panels().forEach(function (p) {
        p.addEventListener('pointerenter', function (e) {
          if (isMouse(e)) cancelClose();
        });
        p.addEventListener('pointerleave', function (e) {
          if (isMouse(e)) scheduleClose();
        });
      });

      /* keyboard: focusing a top-level item opens its panel, leaving closes.
         Pointer-driven focus is skipped — the click handler owns that. */
      nav.addEventListener('focusin', function (e) {
        cancelClose();
        if (focusCameFromTouch) return;
        if (supportsFocusVisible && !e.target.matches(':focus-visible')) return;
        var item = e.target.closest('.ep-nav-item');
        if (!item) return;
        var link = item.querySelector('.ep-nav-link');
        if (link && link.getAttribute('data-haschildren') === '1') openMenu(link.getAttribute('data-menu'));
        else closeMenu();
      });

      nav.addEventListener('focusout', function (e) {
        if (!nav.contains(e.relatedTarget)) closeMenu();
      });
    }

    /* rail: hover, focus, or the chevron switches the pane. The category
       label is a link and is left alone so its click can navigate. */
    root.querySelectorAll('.ep-rail2').forEach(function (rail) {
      var rows = rail.querySelectorAll('.ep-rail2-row');
      var panes = rail.querySelectorAll('.ep-rail2-pane');

      function activate(idx) {
        rows.forEach(function (r, i) {
          var on = i === idx;
          r.classList.toggle('is-active', on);
          var toggle = r.querySelector('.ep-rail2-toggle');
          if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        panes.forEach(function (p, i) {
          p.classList.toggle('is-active', i === idx);
        });
      }

      rows.forEach(function (row, i) {
        row.addEventListener('mouseenter', function () {
          activate(i);
        });
        row.addEventListener('focusin', function () {
          activate(i);
        });
        row.addEventListener('click', function (e) {
          if (e.target.closest('a[href]')) return;
          activate(i);
        });
      });
    });

    /* --------------------------- mobile drawer --------------------------- */
    var drawer = root.querySelector('.ep-md');
    var burger = root.querySelector('[data-ep-burger]');

    if (drawer) {
      var panel = drawer.querySelector('.ep-md-panel');
      var levels = drawer.querySelectorAll('.ep-md-level');
      var headEl = drawer.querySelector('[data-md-head]');
      var titleEl = drawer.querySelector('[data-md-title]');
      var backBtn = drawer.querySelector('[data-md-back]');
      var viewallEl = drawer.querySelector('[data-md-viewall]');
      var viewallLabel = viewallEl ? viewallEl.querySelector('span') : null;
      var viewallTemplate = viewallEl ? viewallEl.getAttribute('data-label-template') || 'View all {{ title }}' : '';
      var lastFocused = null;

      function levelById(id) {
        return drawer.querySelector('.ep-md-level[data-mlevel="' + id + '"]');
      }

      // depth-based z-index so push/pop always animate over the right neighbour
      levels.forEach(function (l) {
        var d = 0;
        var p = l.getAttribute('data-parent');
        while (p) {
          d++;
          var pe = levelById(p);
          p = pe ? pe.getAttribute('data-parent') : null;
        }
        l.style.zIndex = String(10 + d);
      });

      function showLevel(id) {
        var target = levelById(id);
        if (!target) return;

        var ancestors = {};
        var p = target.getAttribute('data-parent');
        while (p) {
          ancestors[p] = 1;
          var pe = levelById(p);
          p = pe ? pe.getAttribute('data-parent') : null;
        }

        levels.forEach(function (l) {
          var lid = l.getAttribute('data-mlevel');
          l.classList.remove('is-active', 'is-prev');
          if (lid === id) l.classList.add('is-active');
          else if (ancestors[lid]) l.classList.add('is-prev');
          // keep off-screen levels out of the tab order and the a11y tree
          l.inert = lid !== id;
        });

        var isRoot = id === 'root';
        var title = target.getAttribute('data-title') || '';
        if (titleEl) titleEl.textContent = title || titleEl.getAttribute('data-default') || '';
        if (headEl) headEl.classList.toggle('is-nav', !isRoot);

        if (!isRoot) {
          if (viewallEl) {
            viewallEl.setAttribute('href', target.getAttribute('data-allurl') || '#');
            if (viewallLabel) viewallLabel.textContent = viewallTemplate.replace('{{ title }}', title);
          }
          if (backBtn) backBtn.setAttribute('data-back-to', target.getAttribute('data-parent') || 'root');
        }
        target.scrollTop = 0;
      }

      function focusables() {
        return Array.prototype.filter.call(
          panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
          function (el) {
            return !el.closest('[inert]') && !el.disabled && el.offsetParent !== null;
          }
        );
      }

      function openDrawer() {
        lastFocused = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (burger) burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        // lifts .section-header above the sibling trust/announcement bars
        document.documentElement.classList.add('ep-drawer-open');
        var first = focusables()[0];
        if (first) first.focus();
      }

      function closeDrawer() {
        if (!drawer.classList.contains('is-open')) return;
        // move focus out before hiding, or the drawer is aria-hidden while it
        // still holds focus — restore to whatever opened it, else the burger
        var restore = lastFocused && lastFocused !== document.body ? lastFocused : burger;
        if (restore && restore.focus) restore.focus();
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        document.documentElement.classList.remove('ep-drawer-open');
        setTimeout(function () {
          showLevel('root');
        }, 280);
      }

      root.__epCloseDrawer = closeDrawer;

      if (burger) burger.addEventListener('click', openDrawer);

      drawer.querySelectorAll('[data-md-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });

      /* Only the chevron (or a label with no URL) carries data-go. Parent
         links are plain anchors, so this handler cannot swallow them. */
      drawer.querySelectorAll('[data-go]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.tagName === 'A') return;
          showLevel(btn.getAttribute('data-go'));
        });
      });

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          showLevel(backBtn.getAttribute('data-back-to') || 'root');
        });
      }

      // keep Tab inside the open drawer
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      showLevel('root');
    }
  }

  function boot() {
    document.querySelectorAll('.epaws-header').forEach(initRoot);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    roots.forEach(function (root) {
      if (root.__epCloseMenu) root.__epCloseMenu();
      if (root.__epCloseDrawer) root.__epCloseDrawer();
    });
  });

  // touch has no hover-out, so a tap anywhere outside the nav dismisses a panel
  document.addEventListener('pointerdown', function (e) {
    roots.forEach(function (root) {
      var nav = root.querySelector('.ep-nav');
      if (nav && !nav.contains(e.target) && root.__epCloseMenu) root.__epCloseMenu();
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // theme editor: re-init when the header section is reloaded
  document.addEventListener('shopify:section:load', function () {
    roots = roots.filter(function (r) {
      return r.isConnected;
    });
    boot();
  });
})();
